<template>
  <div v-loading="loading" class="admin">
    <div v-show="showInputSelection" class="inputSelection">
      <h2>Criar Livro(s)</h2>
      <el-button type="primary" @click="inputFormHandler"
        >Inserir dados</el-button
      >
      <el-button type="primary" @click="inputFileHandler"
        >A partir de um arquivo</el-button
      >
    </div>
    <div v-show="showFormInput" class="content">
      <h2>Criar Livro</h2>
      <el-form ref="form" :model="book" label-width="120px">
        <el-row :gutter="20">
          <el-col :lg="8" :offset="4">
            <el-form-item label="ISBN">
              <el-input v-model="book.isbn" @blur="searchBookByISBN"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8">
            <el-form-item label="Código">
              <el-input v-model="book.code"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="8" :offset="4">
            <el-form-item label="Titulo">
              <el-input v-model="book.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <section v-for="(item, index) in authors" :key="index">
          <el-row :gutter="20">
            <el-col :lg="8" :offset="4">
              <el-form-item label="Autor">
                <el-input v-model="authors[index]"></el-input>
              </el-form-item>
            </el-col>
            <el-col :lg="8">
              <el-button
                type="warn"
                v-on:click="removeFromArray('authors', index)"
                >Remover Autor</el-button
              >
            </el-col>
          </el-row>
        </section>
        <el-row :gutter="20">
          <el-col :lg="8" :offset="4">
            <el-form-item>
              <el-button type="primary" v-on:click="addEmptyString('authors')"
                >Adicionar Autor</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="8" :offset="4">
            <el-form-item label="Editora">
              <el-input v-model="book.publisher"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8">
            <el-form-item label="Edição">
              <el-input v-model="book.edition"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="8" :offset="4">
            <el-form-item label="Cidade">
              <el-input v-model="book.city"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8">
            <el-form-item label="Ano">
              <el-date-picker
                type="year"
                placeholder="Escolha um ano"
                v-model="book.year"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="8" :offset="4">
            <el-form-item label="Capa">
              <file-upload />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="16" :offset="4">
            <el-form-item label="Descrição">
              <el-input
                autosize
                type="textarea"
                v-model="book.description"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="8" :offset="4">
            <el-form-item label="Categoria(s)">
              <el-select
                v-model="tagIds"
                filterable
                clearable
                remote
                v-bind:placeholder="Tag"
                :remote-method="searchTags"
                :loading="loading"
                multiple
              >
                <el-option
                  v-for="tag in tags"
                  :key="tag._id.$oid"
                  :label="tag.value"
                  :value="tag._id.$oid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="16" :offset="4">
            <el-form-item class="form-buttons">
              <el-button type="primary" @click="createBook">Criar</el-button>
              <el-button @click="clearBook">Cancelar</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="fileInput" v-show="showFileInput">
      <h2>Carregar Livros por CSV</h2>
      <el-upload
        action=""
        ref="upload"
        :auto-upload="false"
        :limit="1"
        :on-change="handleFileUpload"
      >
        <template #trigger>
          <el-button type="primary">Selecionar Arquivo</el-button>
        </template>
        <el-button id="create-button" type="success" @click="submitFile"
          >Criar</el-button
        >
      </el-upload>
    </div>
  </div>

  <div class="feedbackTable">
    <el-table
      v-if="showCSVFeedback"
      :data="CSVUploadResult"
      :row-class-name="tableRowClassName"
    >
      <el-table-column prop="code" label="Código da Obra"> </el-table-column>
      <el-table-column prop="status" label="Status"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { createBook, createBookCSV } from "../../../services/book";
import { searchTags } from "../../../services/tags";
import { searchGoogleBooksByIsbn } from "../../../services/googleBooks";
import FileUpload from "../../../partials/FileUpload.vue";
export default {
  components: {
    "file-upload": FileUpload,
  },
  data() {
    return {
      imageUrl: "",
      book: {},
      authors: [],
      file: "",
      year: null,
      showInputSelection: true,
      showFormInput: false,
      showFileInput: false,
      loading: false,
      CSVUploadResult: [],
      showCSVFeedback: false,
      tags: [],
      tagIds: [],
    };
  },

  methods: {
    searchTags(query) {
      if (query) {
        var params = {};
        params.value = query;
        this.loading = true;
        searchTags(params).then((response) => {
          if (response.status === 200) {
            this.loading = false;
            this.tags = response.data;
          }
        });
        this.loading = false;
      }
    },
    async searchBookByISBN() {
      if (this.book.isbn) {
        this.loading = true;
        const response = await searchGoogleBooksByIsbn(this.book.isbn);
        this.loading = false;
        if (response.status == 200 && response.data.totalItems > 0) {
          const shouldFillData = await this.$confirm(
            "Encontrei algumas informações sobre esse livro, posso tentar preencher o que você nao preencheu ainda?",
            "Olá",
            {
              confirmButtonText: "Confirmar",
              cancelButtonText: "Cancelar",
              type: "warning",
            }
          );
          if (shouldFillData) {
            this.fillBookWithGoogleData(response.data.items[0]);
          }
        }
      }
    },
    fillBookWithGoogleData(googleBook) {
      if (googleBook.volumeInfo) {
        if (!this.book.title) {
          this.book.title = googleBook.volumeInfo.title;
        }
        if (
          this.authors.length == 0 ||
          (this.authors.length == 1 && this.authors[0] == "")
        ) {
          this.authors = googleBook.volumeInfo.authors;
        }
        if (!this.book.publisher) {
          this.book.publisher = googleBook.volumeInfo.publisher;
        }
        if (!this.book.description) {
          this.book.description = googleBook.volumeInfo.description;
        }
        if (!this.book.cover) {
          this.book.cover = googleBook.volumeInfo.imageLinks.thumbnail;
        }
      }
    },
    removeFromArray(name, index) {
      this[name].splice(index, 1);
    },
    addEmptyString(name) {
      this[name].push("");
      console.info(this.authors);
    },
    inputFormHandler() {
      this.showFormInput = true;
      this.showInputSelection = false;
    },

    inputFileHandler() {
      this.showFileInput = true;
      this.showInputSelection = false;
    },

    async createBook() {
      if (this.book.year != null) {
        this.book.year = String(this.book.year.getFullYear());
      }
      if (this.authors["length"] == "") {
        this.authors.pop();
      }
      this.book.authors = this.authors;
      this.book.tag_ids = this.tagIds;
      const response = await createBook(this.book);
      if (response.status === 201) {
        this.$message.success("Livro criado com sucesso!");
        this.$router.push(`/admin/books`);
      }
    },

    clearBook() {
      this.book = {};
    },

    handleFileUpload(event) {
      this.file = event.raw;
    },

    async submitFile() {
      const response = await createBookCSV(this.file);
      if (response.status === 200) {
        this.showCSVFeedback = true;
        this.CSVUploadResult = [];
        var a = response.data.split(";");
        for (var i = 1; i < a.length - 1; i++) {
          var b = a[i].split(",");
          b[0] = b[0].replace('"\n', "");
          b[0] = b[0].replace("\n", "");
          b[1] = b[1].replace('"\n', "");
          this.CSVUploadResult.push({ code: b[0], status: b[1] });
        }
      }
    },

    tableRowClassName({ row }) {
      var rowTarget = Object.assign({}, row);
      if (rowTarget.status == "Item criado com sucesso!") {
        return "success-row";
      } else {
        return "warning-row";
      }
    },
  },

  mounted() {
    this.emitter.on("image", (coverUrl) => {
      this.book.cover = coverUrl;
    });
  },
};
</script>

<style>
.el-table .success-row {
  background-color: #e6ffe6;
}

.el-table .warning-row {
  background-color: #ffcccc;
}

h1,
h2 {
  font-weight: normal;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.inputSelection {
  text-align: center;
}

.admin {
  margin: 30px;
}

.fileInput {
  text-align: center;
}

.feedbackTable {
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 2%;
}

.form-buttons {
  float: right;
}

#create-button {
  margin-left: 10px;
}
</style>
